import React from 'react';
import constants from '../../../config';
import { formatDate } from './formatters';
import UserOrdersTab from './UserOrdersTab';
import UserListingsTab from './UserListingsTab';

export default function UserDetailModal(props) {
  var isDark = document.documentElement.classList.contains('tw-dark');
  if (!props.userId) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-justify-end" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
      <div className="tw-w-full tw-max-w-md tw-h-full tw-overflow-y-auto tw-shadow-2xl" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', borderLeft: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }} onClick={function(e) { e.stopPropagation(); }}>
        <UserModalContent
          loading={props.loading}
          detail={props.detail}
          tab={props.tab}
          noteText={props.noteText}
          strikeReason={props.strikeReason}
          strikeDetails={props.strikeDetails}
          suspendReason={props.suspendReason}
          suspendDuration={props.suspendDuration}
          banReason={props.banReason}
          roleChangeValue={props.roleChangeValue}
          actionLoading={props.actionLoading}
          onClose={props.onClose}
          onTabChange={props.onTabChange}
          onNoteChange={props.onNoteChange}
          onStrikeReasonChange={props.onStrikeReasonChange}
          onStrikeDetailsChange={props.onStrikeDetailsChange}
          onSuspendReasonChange={props.onSuspendReasonChange}
          onSuspendDurationChange={props.onSuspendDurationChange}
          onBanReasonChange={props.onBanReasonChange}
          onRoleChangeValueChange={props.onRoleChangeValueChange}
          onChangeRole={props.onChangeRole}
          onAddNote={props.onAddNote}
          onAddStrike={props.onAddStrike}
          onRemoveStrike={props.onRemoveStrike}
          onSuspend={props.onSuspend}
          onBan={props.onBan}
          onUnsuspend={props.onUnsuspend}
          onUnban={props.onUnban}
          adminMessage={props.adminMessage}
          adminMessageSending={props.adminMessageSending}
          adminMessageSent={props.adminMessageSent}
          adminMessageConvoId={props.adminMessageConvoId}
          onAdminMessageChange={props.onAdminMessageChange}
          onSendAdminMessage={props.onSendAdminMessage}
          onViewConversation={props.onViewConversation}
        />
      </div>
      <div className="tw-absolute tw-inset-0 tw--z-10" onClick={props.onClose} />
    </div>
  );
}

function UserModalContent(props) {
  var isDark = document.documentElement.classList.contains('tw-dark');
  var loading = props.loading;
  var detail = props.detail;
  var tab = props.tab;

  if (loading) {
    return (
      <div className="tw-p-6 tw-text-center tw-py-16">
        <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
        <span className="tw-text-sm tw-text-[#999]">Loading user...</span>
      </div>
    );
  }

  if (!detail || !detail.user) {
    return (
      <div className="tw-p-6 tw-text-center tw-py-16">
        <span className="tw-text-sm tw-text-[#999]">User not found</span>
        <button className="tw-block tw-mx-auto tw-mt-4 tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer" onClick={props.onClose}>Close</button>
      </div>
    );
  }

  var user = detail.user;
  var stats = detail.stats || {};
  var notes = (user.adminNotes || []).slice().reverse();
  var strikes = (user.strikes || []).slice().reverse();

  var roleBadgeColor = user.role === 'admin' ? '#D4A843' : '#6B7280';
  var shopBadgeColor = user.shopActive !== false ? '#10B981' : '#EF4444';

  return (
    <div>
      {/* Header */}
      <div className="tw-sticky tw-top-0 tw-px-5 tw-py-4 tw-z-10" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h3 className="tw-text-base tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">User Details</h3>
          <button className="tw-w-8 tw-h-8 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]" onClick={props.onClose}>
            <i className="fa fa-times" />
          </button>
        </div>
        <div className="tw-flex tw-items-center tw-gap-3">
          {user.image ? (
            <img src={user.image.startsWith('http') ? user.image : constants.DOMAIN + '/' + user.image} alt="" className="tw-w-12 tw-h-12 tw-rounded-full tw-object-cover tw-flex-shrink-0" />
          ) : (
            <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
              <i className="fa fa-user tw-text-[#ccc]" />
            </div>
          )}
          <div className="tw-flex-1 tw-min-w-0">
            <div className="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
              <span className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white">{user.userName || 'Unknown'}</span>
              <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: roleBadgeColor }}>{user.role || 'user'}</span>
              <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: shopBadgeColor }}>{user.shopActive !== false ? 'Shop Open' : 'Shop Closed'}</span>
              {user.status === 'suspended' && (
                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold tw-text-black" style={{ backgroundColor: '#f59e0b' }}>Suspended</span>
              )}
              {user.status === 'banned' && (
                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold tw-text-white" style={{ backgroundColor: '#EF4444' }}>Banned</span>
              )}
              {strikes.length > 0 && (
                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold tw-text-white" style={{ backgroundColor: '#EF4444' }}>{strikes.length} strike{strikes.length !== 1 ? 's' : ''}</span>
              )}
            </div>
            <div className="tw-text-xs tw-text-[#999] tw-mt-0.5">{user.email || ''}</div>
          </div>
        </div>
        <div className="tw-flex tw-gap-4 tw-mt-3 tw-text-xs tw-text-[#999]">
          <span><i className="fa fa-calendar tw-mr-1" />Joined {user.createdAt ? formatDate(user.createdAt) : 'N/A'}</span>
          <span><i className="fa fa-exchange tw-mr-1" />{stats.txCount || 0} transactions</span>
          <span><i className="fa fa-flag tw-mr-1" />{stats.reportedCount || 0} reported</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="tw-flex" style={{ borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
        <button
          className={'tw-flex-1 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-bg-transparent ' + (tab === 'notes' ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#999] hover:tw-text-[#666]')}
          style={tab === 'notes' ? { borderBottom: '2px solid #D4A843' } : {}}
          onClick={function() { props.onTabChange('notes'); }}
        >
          <i className="fa fa-sticky-note-o tw-mr-1" />Notes ({notes.length})
        </button>
        <button
          className={'tw-flex-1 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-bg-transparent ' + (tab === 'strikes' ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#999] hover:tw-text-[#666]')}
          style={tab === 'strikes' ? { borderBottom: '2px solid #EF4444' } : {}}
          onClick={function() { props.onTabChange('strikes'); }}
        >
          <i className="fa fa-exclamation-circle tw-mr-1" />Strikes ({strikes.length})
        </button>
        <button
          className={'tw-flex-1 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-bg-transparent ' + (tab === 'actions' ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#999] hover:tw-text-[#666]')}
          style={tab === 'actions' ? { borderBottom: '2px solid #8B5CF6' } : {}}
          onClick={function() { props.onTabChange('actions'); }}
        >
          <i className="fa fa-gavel tw-mr-1" />Actions
        </button>
        <button
          className={'tw-flex-1 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-bg-transparent ' + (tab === 'orders' ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#999] hover:tw-text-[#666]')}
          style={tab === 'orders' ? { borderBottom: '2px solid #3B82F6' } : {}}
          onClick={function() { props.onTabChange('orders'); }}
        >
          <i className="fa fa-exchange tw-mr-1" />Orders
        </button>
        <button
          className={'tw-flex-1 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-border-0 tw-cursor-pointer tw-bg-transparent ' + (tab === 'listings' ? 'tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-text-[#999] hover:tw-text-[#666]')}
          style={tab === 'listings' ? { borderBottom: '2px solid #10B981' } : {}}
          onClick={function() { props.onTabChange('listings'); }}
        >
          <i className="fa fa-tag tw-mr-1" />Listings
        </button>
      </div>

      {/* Tab Content */}
      <div className="tw-p-5">
        {tab === 'notes' && (
          <div>
            <div className="tw-mb-5">
              <textarea
                className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                rows={3}
                placeholder="Add an admin note..."
                value={props.noteText}
                onChange={function(e) { props.onNoteChange(e.target.value); }}
              />
              <button
                className="tw-mt-2 tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                style={{ backgroundColor: '#D4A843' }}
                disabled={!props.noteText.trim() || props.actionLoading}
                onClick={props.onAddNote}
              >
                {props.actionLoading ? <i className="fa fa-spinner fa-spin" /> : 'Add Note'}
              </button>
            </div>
            {notes.length === 0 && (
              <p className="tw-text-sm tw-text-[#999] tw-text-center tw-py-8 tw-m-0">No admin notes yet</p>
            )}
            <div className="tw-space-y-3">
              {notes.map(function(n, i) {
                return (
                  <div key={n._id || i} className="tw-p-3 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                    <div className="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                      <span className="tw-text-xs tw-font-semibold" style={{ color: '#D4A843' }}>{n.addedBy ? n.addedBy.userName : 'Admin'}</span>
                      <span className="tw-text-xs tw-text-[#999]">{n.createdAt ? formatDate(n.createdAt) : ''}</span>
                    </div>
                    <p className="tw-text-sm tw-text-[#444] dark:tw-text-[#ccc] tw-m-0">{n.note}</p>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === 'strikes' && (
          <div>
            <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
              <input
                type="text"
                className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2"
                placeholder="Strike reason (required)"
                value={props.strikeReason}
                onChange={function(e) { props.onStrikeReasonChange(e.target.value); }}
              />
              <textarea
                className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                rows={2}
                placeholder="Additional details (optional)"
                value={props.strikeDetails}
                onChange={function(e) { props.onStrikeDetailsChange(e.target.value); }}
              />
              <button
                className="tw-mt-2 tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                style={{ backgroundColor: '#EF4444' }}
                disabled={!props.strikeReason.trim() || props.actionLoading}
                onClick={props.onAddStrike}
              >
                {props.actionLoading ? <i className="fa fa-spinner fa-spin" /> : 'Add Strike'}
              </button>
            </div>
            {strikes.length === 0 && (
              <p className="tw-text-sm tw-text-[#999] tw-text-center tw-py-8 tw-m-0">No strikes on record</p>
            )}
            <div className="tw-space-y-3">
              {strikes.map(function(s, i) {
                return (
                  <div key={s._id || i} className="tw-p-3 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                    <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <span className="tw-text-xs tw-font-bold" style={{ color: '#EF4444' }}><i className="fa fa-exclamation-circle tw-mr-1" />Strike</span>
                        <span className="tw-text-xs tw-text-[#999]">{s.createdAt ? formatDate(s.createdAt) : ''}</span>
                        <span className="tw-text-xs tw-text-[#999]">by {s.addedBy ? s.addedBy.userName : 'Admin'}</span>
                      </div>
                      <button
                        className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#EF4444]"
                        onClick={function() { props.onRemoveStrike(s._id); }}
                        title="Remove strike"
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </div>
                    <div className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{s.reason}</div>
                    {s.details && <div className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-mt-1">{s.details}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === 'actions' && (
          <div>
            {/* Direct Message Composer */}
            <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
              <h4 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-1">
                <i className="fa fa-envelope tw-mr-1" style={{ color: '#8B5CF6' }} />Direct Message
              </h4>
              <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mb-3">Send a message to this user as Primal Support.</p>
              {props.adminMessageSent ? (
                <div className="tw-text-center tw-py-3">
                  <i className="fa fa-check-circle tw-text-2xl tw-mb-2" style={{ color: '#10B981', display: 'block' }} />
                  <p className="tw-text-sm tw-font-medium tw-m-0 tw-mb-2" style={{ color: '#10B981' }}>Message sent!</p>
                  <button
                    onClick={props.onViewConversation}
                    className="tw-text-xs tw-font-medium tw-border-0 tw-bg-transparent tw-cursor-pointer hover:tw-underline"
                    style={{ color: '#8B5CF6' }}
                  >
                    View conversation &rarr;
                  </button>
                </div>
              ) : (
                <div>
                  <div className="tw-relative">
                    <textarea
                      className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                      rows={3}
                      maxLength={500}
                      placeholder="Type your message..."
                      value={props.adminMessage}
                      onChange={function(e) { props.onAdminMessageChange(e.target.value); }}
                      onKeyDown={function(e) {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          if (props.adminMessage.trim() && !props.adminMessageSending) {
                            props.onSendAdminMessage();
                          }
                        }
                      }}
                      disabled={props.adminMessageSending}
                    />
                    <span className="tw-text-[10px] tw-text-[#999] tw-absolute tw-bottom-2 tw-right-3">{(props.adminMessage || '').length}/500</span>
                  </div>
                  <button
                    className="tw-mt-2 tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                    style={{ backgroundColor: '#8B5CF6', opacity: (!props.adminMessage.trim() || props.adminMessageSending) ? 0.4 : 1, cursor: (!props.adminMessage.trim() || props.adminMessageSending) ? 'not-allowed' : 'pointer' }}
                    disabled={!props.adminMessage.trim() || props.adminMessageSending}
                    onClick={props.onSendAdminMessage}
                  >
                    {props.adminMessageSending ? <i className="fa fa-spinner fa-spin" /> : <span><i className="fa fa-paper-plane tw-mr-1" />Send Message</span>}
                  </button>
                </div>
              )}
            </div>
            {/* Role Management */}
            <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
              <h4 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-3">
                <i className="fa fa-users tw-mr-1" style={{ color: '#3B82F6' }} />User Role
              </h4>
              <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                <span className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa]">Current:</span>
                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: user.role === 'admin' ? '#D4A843' : '#6B7280' }}>{user.role || 'user'}</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-2">
                <select
                  className="tw-flex-1 tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white"
                  value={props.roleChangeValue || ''}
                  onChange={function(e) { props.onRoleChangeValueChange(e.target.value); }}
                >
                  <option value="">Select new role...</option>
                  {user.role !== 'user' && <option value="user">User</option>}
                  {user.role !== 'admin' && <option value="admin">Admin</option>}
                </select>
                <button
                  className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 hover:tw-opacity-90"
                  style={{ backgroundColor: '#3B82F6', opacity: (!props.roleChangeValue || props.actionLoading) ? 0.4 : 1, cursor: (!props.roleChangeValue || props.actionLoading) ? 'not-allowed' : 'pointer' }}
                  disabled={!props.roleChangeValue || props.actionLoading}
                  onClick={props.onChangeRole}
                >
                  {props.actionLoading ? <i className="fa fa-spinner fa-spin" /> : 'Change'}
                </button>
              </div>
            </div>

            {user.status === 'suspended' && (
              <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border" style={{ backgroundColor: 'rgba(245,158,11,0.1)', borderColor: '#f59e0b' }}>
                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                  <i className="fa fa-pause-circle" style={{ color: '#f59e0b' }} />
                  <span className="tw-text-sm tw-font-bold" style={{ color: '#f59e0b' }}>Account Suspended</span>
                </div>
                {user.suspendedReason && (
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-m-0 tw-mb-1"><strong>Reason:</strong> {user.suspendedReason}</p>
                )}
                {user.suspendedUntil && (
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-m-0 tw-mb-1"><strong>Until:</strong> {new Date(user.suspendedUntil).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                )}
                {user.suspendedAt && (
                  <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mb-3">Suspended on {new Date(user.suspendedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                )}
                <button
                  className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                  style={{ backgroundColor: '#10B981' }}
                  disabled={props.actionLoading}
                  onClick={props.onUnsuspend}
                >
                  <i className="fa fa-check-circle tw-mr-1" />Lift Suspension
                </button>
              </div>
            )}

            {user.status === 'banned' && (
              <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border" style={{ backgroundColor: 'rgba(239,68,68,0.1)', borderColor: '#EF4444' }}>
                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                  <i className="fa fa-ban" style={{ color: '#EF4444' }} />
                  <span className="tw-text-sm tw-font-bold" style={{ color: '#EF4444' }}>Account Permanently Banned</span>
                </div>
                {user.bannedReason && (
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-m-0 tw-mb-1"><strong>Reason:</strong> {user.bannedReason}</p>
                )}
                {user.bannedAt && (
                  <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mb-3">Banned on {new Date(user.bannedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                )}
                <button
                  className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                  style={{ backgroundColor: '#10B981' }}
                  disabled={props.actionLoading}
                  onClick={props.onUnban}
                >
                  <i className="fa fa-check-circle tw-mr-1" />Lift Ban
                </button>
              </div>
            )}

            {user.status !== 'banned' && user.status !== 'suspended' && (
              <div className="tw-mb-5 tw-p-4 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                <h4 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-3">
                  <i className="fa fa-pause-circle tw-mr-1" style={{ color: '#f59e0b' }} />Suspend User
                </h4>
                <div className="tw-mb-2">
                  <label className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-block tw-mb-1">Duration</label>
                  <select
                    className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white"
                    value={props.suspendDuration}
                    onChange={function(e) { props.onSuspendDurationChange(e.target.value); }}
                  >
                    <option value="1">1 day</option>
                    <option value="3">3 days</option>
                    <option value="7">7 days</option>
                    <option value="14">14 days</option>
                    <option value="30">30 days</option>
                    <option value="90">90 days</option>
                  </select>
                </div>
                <div className="tw-mb-2">
                  <label className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-block tw-mb-1">Reason</label>
                  <textarea
                    className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                    rows={2}
                    placeholder="Reason for suspension (required)"
                    value={props.suspendReason}
                    onChange={function(e) { props.onSuspendReasonChange(e.target.value); }}
                  />
                </div>
                <button
                  className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-black tw-border-0 hover:tw-opacity-90"
                  style={{ backgroundColor: '#f59e0b', opacity: (!props.suspendReason.trim() || props.actionLoading) ? 0.4 : 1, cursor: (!props.suspendReason.trim() || props.actionLoading) ? 'not-allowed' : 'pointer' }}
                  disabled={!props.suspendReason.trim() || props.actionLoading}
                  onClick={props.onSuspend}
                >
                  {props.actionLoading ? <i className="fa fa-spinner fa-spin" /> : 'Suspend User'}
                </button>
              </div>
            )}

            {user.status !== 'banned' && (
              <div className="tw-p-4 tw-rounded-lg tw-border tw-border-[#eee] dark:tw-border-[#222]">
                <h4 className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0 tw-mb-3">
                  <i className="fa fa-ban tw-mr-1" style={{ color: '#EF4444' }} />Permanent Ban
                </h4>
                <div className="tw-mb-2">
                  <label className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-block tw-mb-1">Reason</label>
                  <textarea
                    className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                    rows={2}
                    placeholder="Reason for permanent ban (required)"
                    value={props.banReason}
                    onChange={function(e) { props.onBanReasonChange(e.target.value); }}
                  />
                </div>
                <button
                  className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 hover:tw-opacity-90"
                  style={{ backgroundColor: '#EF4444', opacity: (!props.banReason.trim() || props.actionLoading) ? 0.4 : 1, cursor: (!props.banReason.trim() || props.actionLoading) ? 'not-allowed' : 'pointer' }}
                  disabled={!props.banReason.trim() || props.actionLoading}
                  onClick={props.onBan}
                >
                  {props.actionLoading ? <i className="fa fa-spinner fa-spin" /> : 'Ban Permanently'}
                </button>
              </div>
            )}

            {user.role === 'admin' && (
              <div className="tw-mt-4 tw-p-3 tw-rounded-lg tw-text-center" style={{ backgroundColor: 'rgba(212,168,67,0.1)' }}>
                <p className="tw-text-xs tw-m-0" style={{ color: '#D4A843' }}>
                  <i className="fa fa-shield tw-mr-1" />Admin accounts cannot be suspended or banned
                </p>
              </div>
            )}
          </div>
        )}

        {tab === 'orders' && (
          <UserOrdersTab userId={user._id} />
        )}

        {tab === 'listings' && (
          <UserListingsTab userId={user._id} />
        )}
      </div>
    </div>
  );
}
